import type { FC, ReactElement } from 'react'
import { ListItem, type ListItemProps, ListItemText, ListItemIcon } from '@dhl-ui/components'
import { LaunchIcon } from '@dhl-ui/icons'

type ExternalLinkMenuItemProps = Omit<
  ListItemProps,
  'alignItems' | 'isButton' | 'isDense' | 'isVertical' | 'onClick' | 'slotProps'
> & {
  /**
   * Text inside our menu item
   */
  label: string

  /**
   * link which we will open in a _blank new window
   */
  href: string

  /**
   * Icon which visually supports the label
   */
  icon: ReactElement
}

export const ExternalLinkMenuItem: FC<ExternalLinkMenuItemProps> = ({ label, href, icon, ...rest }) => {
  const onClick = () => window.open(href, '_blank', 'noreferrer,noopener')

  return (
    <ListItem
      {...rest}
      isDense
      isButton
      alignItems="center"
      slotProps={{ secondaryIcon: <LaunchIcon /> }}
      onClick={onClick}
      sx={{ px: 2 }}
    >
      <ListItemIcon isBlock>{icon}</ListItemIcon>
      <ListItemText primary={label} />
    </ListItem>
  )
}
